import { Pipe, PipeTransform } from '@angular/core';
interface ValueCheckingStatusResult {
  status: string;
  className: string;
}

@Pipe({
  name: 'valueChecking',
})
export class ValueCheckingPipe implements PipeTransform {
  transform(value: string | undefined | null | ''): ValueCheckingStatusResult {
    let result: ValueCheckingStatusResult = {
      status: '',
      className: '',
    };

    if (value) {
      result.status = 'YES';
      result.className = 'success-color';
      return result;
    } else {
        result.status = 'NO';
        result.className = 'error-color';
        return result;
    }
  }
}